// Unity iframe 스타일
export const unityStyled: React.CSSProperties = {
  display: "block",
  width: "100%",
  height: "100vh",
  border: "none",
  outline: "none", // 포커스 시 파란색 하이라이트 제거
  boxShadow: "none",
  WebkitTapHighlightColor: "transparent",
};

// React에서 Unity로 보내는 이벤트 (reactToUnity_)
export const ReactToUnityEvents = {
  CONFIRM_UNITY_READY: "reactToUnity_confirmUnityReady",
  OPERATION_SUCCESS: "reactToUnity_operationSuccess",
  LOADER_VALIDATION_OUTBOX_STORED:
    "reactToUnity_loaderValidationOutboxStored",
  CLEANUP_LOADER_ATTEMPT: "reactToUnity_cleanupLoaderAttempt",
  PROCESS_SIGNED_URL_FILE: "reactToUnity_processSignedUrlFile",
  REQUEST_UPLOAD_BUTTON: "reactToUnity_requestUploadButton",
  URL_COPIED: "reactToUnity_urlCopied",
  MODEL_LOAD_REQUEST: "reactToUnity_modelLoadRequest",
  COMMAND: "reactToUnity_command",
  CAPTURE_THUMBNAIL: "reactToUnity_captureThumbnail",
  XR_OVERLAY_GAZE_OFF: "reactToUnity_xrOverlayGazeOff",
  INSERT_VIEWR_DATA: "reactToUnity_insertViewRData",
  APPLY_VIEWR_DELTA: "reactToUnity_applyViewRDelta",
  REQUEST_RENDER_SNAPSHOT: "reactToUnity_requestRenderSnapshot",
} as const;

// Unity에서 React로 보내는 이벤트 (unityToReact_)
export const UnityToReactEvents = {
  UNITY_READY: "unityToReact_unityReady",
  UNITY_LOADED: "unityToReact_unityLoaded",
  UNITY_STATUS: "unityToReact_unityStatus",
  MODEL_LOAD_COMPLETE: "unityToReact_modelLoadComplete",
  OBJECT_IMPORT_STATE: "unityToReact_objectImportState",
  OBJECT_RENDER_STATE: "unityToReact_objectRenderState",
  RELOAD_MODEL_READY: "unityToReact_reloadModelReady",
  SPACE_SWITCH_RESULT: "unityToReact_spaceSwitchResult",
  SPACE_NAVIGATION_STATE: "unityToReact_spaceNavigationState",
  RUNTIME_READY_STATE: "unityToReact_runtimeReadyState",
  XR_OVERLAY_GAZE_STATE: "unityToReact_xrOverlayGazeState",
  MODEL_SELETED: "unityToReact_isSelectedModel",
  MODEL_DEFAULT: "unityToReact_defaultModel",
  ERROR_OCCURRED: "unityToReact_errorOccurred",
  SHOW_UPLOAD_POPUP: "unityToReact_showUploadPopup",
  SHOW_DELETE_POPUP: "unityToReact_showDeletePopup",
  FILE_PROCESSING_COMPLETE: "unityToReact_fileProcessingComplete",
  FILE_PROCESSING_PROGRESS: "unityToReact_fileProcessingProgress",
  EDIT_SNAPSHOT_READY: "unityToReact_editSnapshotReady",
  EDIT_SNAPSHOT_IMAGES: "unityToReact_editSnapshotImages",
  SAVE_JSON_COMPLETE: "unityToReact_saveJsonComplete",
  MODEL_CHANGED: "unityToReact_modelChanged",
  THUMBNAIL_CAPTURED: "unityToReact_thumbnailCaptured",
  INTERACTION_EVENT: "unityToReact_interactionEvent",
  DELTA_ACK: "unityToReact_deltaAck",
  RUNTIME_ERROR: "unityToReact_runtimeError",
  LOADER_VALIDATION_COMPLETE: "unityToReact_loaderValidationComplete",
} as const;

// 시스템 레벨 통신 메시지 (postMessage 타입)
export const SYSTEM_MESSAGE_TYPES = {
  UNITY_TO_REACT_UNITY_READY: "unityToReact_unityReady",
  UNITY_TO_REACT_UNITY_LOADED: "unityToReact_unityLoaded",
  REACT_TO_UNITY_COMMAND: "reactToUnity_command",
  REACT_TO_UNITY_REACT_READY: "reactToUnity_reactReady",
  REACT_TO_UNITY_QUIT: "REACT_TO_UNITY_QUIT",
} as const;
